module.exports = __webpack_public_path__ + "72691603dcd84502e6bb2f32bd489e8c.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/workshop.jpg
 ** module id = 449
 ** module chunks = 0
 **/